import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, Youtube, Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0B1A4A] text-white pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-emerald-500 flex items-center justify-center">
                <Heart className="w-5 h-5 text-white" fill="white" />
              </div>
              <span className="text-xl font-black" style={{ fontFamily: "Outfit" }}>
                BackCare by Dr. Dhanda
              </span>
            </div>
            <p className="text-sm text-blue-100/70 leading-relaxed">
              Doctor-approved natural back pain relief — practical, safe, and effective.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-emerald-300 mb-4" style={{ fontFamily: "Outfit" }}>
              Contact
            </h4>
            <a
              href="mailto:sudeepm8618@gmail.com"
              className="flex items-center gap-2 text-blue-100/90 hover:text-white transition-colors mb-3"
              data-testid="footer-email"
            >
              <Mail className="w-4 h-4" />
              <span className="text-sm">sudeepm8618@gmail.com</span>
            </a>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                aria-label="YouTube"
                data-testid="footer-youtube"
              >
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-emerald-300 mb-4" style={{ fontFamily: "Outfit" }}>
              Legal
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-blue-100/80 hover:text-white transition-colors" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-blue-100/80 hover:text-white transition-colors" data-testid="footer-terms">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-blue-100/80 hover:text-white transition-colors" data-testid="footer-refund">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="rounded-2xl bg-white/5 border border-white/10 p-5 mb-8">
          <p className="text-xs text-blue-100/70 leading-relaxed">
            <span className="font-bold text-blue-100">Medical Disclaimer:</span> This guide is for
            educational purposes only and does not replace professional medical advice. The exercises
            and recommendations are general suggestions. If you have severe pain, a pre-existing
            condition, or recent injury, consult a qualified physician before starting any new
            routine. Results may vary from person to person.
          </p>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-blue-100/60">
            © {new Date().getFullYear()} BackCare by Dr. Akshay Dhanda. All rights reserved.
          </p>
          <p className="text-xs text-blue-100/60 flex items-center gap-1">
            Made with <Heart className="w-3 h-3 text-rose-400 fill-rose-400" /> for healthier spines
          </p>
        </div>
      </div>
    </footer>
  );
}
